import { NgModule } from '@angular/core';
import { Windows11AssessmentComponent } from './windows-11-assessment.component';
import { Windows11ReportComponent } from './report/windows-11-report.component';
import { Routes, RouterModule } from '@angular/router';
import { Windows11ReportExtractComponent } from './report/report-extract/windows-11-report-extract.component';



const routes: Routes = [
  {
    path: 'windows-11-readiness',
    component: Windows11AssessmentComponent,
    data:{
      breadcrumb: 'windows-11-readiness',
    },
    children: [
      {
        path: "windows-11-report",
        component: Windows11ReportComponent,
        data: {
          breadcrumb: "windows-11-report",
        },
        children: [
          {
            path: "windows-11-report-extract",
            component: Windows11ReportExtractComponent,
            data: {
              breadcrumb: "windows-11-report-extract",
            },
          }
        ]
      },
      {
        path: "windows-11-extract-report",
        component: Windows11ReportExtractComponent,
        data: {
          breadcrumb: "windows-11-report-extract",
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class Windows11AssessmentRoutingModule {} 
